import React from 'react';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import { setModalContent, setFiltersContent, setSelectedFilters } from '../actionCreators';
import configData from "../config.json";
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Table from '../components/Table';
import StackBarChart from '../components/StackBarChart';
import LinesChart from '../components/LinesChart';
import Filters from '../components/Filters';
import $ from 'jquery';

/*
import SimpleBarChart from '../components/SimpleBarChart';
import PieChart from '../components/PieChart';
import AreaChart from '../components/AreaChart';
*/

class Reports extends BasePage {

	loadOnConstructor() {
		this.parseResponse = this.parseResponse.bind(this);
		this.getInterface = this.getInterface.bind(this);
		this.altTab = this.altTab.bind(this);
		this.showFilters = this.showFilters.bind(this);
		this.filterResults = this.filterResults.bind(this);
		this.parseDateToString = this.parseDateToString.bind(this);
		this.parseReportResponse = this.parseReportResponse.bind(this);
		this.reloadData = this.reloadData.bind(this);
		this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
		this.labelForChart = this.labelForChart.bind(this);
		this.excelExport = this.excelExport.bind(this);

		const currentYearData = [
			{ x: "Enero", y: 130 },
			{ x: "Febrero", y: 150 },
			{ x: "Marzo", y: 230 },
			{ x: "Abril", y: 430 },
			{ x: "Mayo", y: 830 },
			{ x: "Junio", y: 1130 },
			{ x: "Julio", y: 1830 },
		]

		let initialStartDate = new Date();
		let initialEndDate = new Date();
		initialStartDate.setDate(1);
		initialStartDate.setHours(0);
		initialStartDate.setMinutes(0);
		initialStartDate.setSeconds(0);

		initialEndDate.setMonth(initialStartDate.getMonth() + 1);
		initialEndDate.setDate(0);
		initialEndDate.setHours(23);
		initialEndDate.setMinutes(59);
		initialEndDate.setSeconds(59);

		const initialActiveReportDate = true;
		const initialActiveOperations = false;
		const initialActiveBillType = false;

		let filters = []
		filters.push({ name: "reports_date_start", value: this.parseDateToString(initialStartDate) });
		filters.push({ name: "reports_date_end", value: this.parseDateToString(initialEndDate) });

		const billType =  [{_id: 1, name:'Factura'}, {_id: 2, name:'Factura rectificativa'}]
		this.state = {
			searchParams: filters,
			initialStartDate,
			initialEndDate,
			initialActiveReportDate,
			initialActiveOperations,
			initialActiveBillType,
			billType,
			currentYearData: currentYearData
		};

		this.getInterface('interface');
	}

	getInterface(type) {
		const api = this.getApi();
		
		let apiParams = [
			{ name: 'page', value: this.state.page ? this.state.page : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		if (this.state.searchParams) {
			apiParams = apiParams.concat(this.state.searchParams);
		}

		if (type === 'interface') {
			api.getReportsInterface(apiParams, this.parseResponse);
		} else if (type === 'download') {
			apiParams.push({ name: 'export_to_file', value: 1 });
			api.downloadReport(apiParams, this.parseReportResponse);
		} else {
			api.getReports(apiParams, this.parseReportResponse);
		}
	}

	excelExport(){
		this.setState(prevState => {
			return {
				...prevState,
				download: true
			}
		},this.getInterface.bind(this,'download'));
	}

	generateDateKey(stringDate){
		const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  			"Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

		const d = new Date(stringDate);
		var parts = stringDate.split('-');

		return monthNames[d.getMonth()]+' '+parts[0].substring(2,4)
	}

	fillSelectedMonthsChartData(response){
		let data = []
		let finalData = []
		let labels = []
		const ops = this.state.operations??response.operations
		if(response.allData){
			response.allData.forEach(dat => {

				let dataIndex = String(dat.line.operation)
				let xaxis = this.generateDateKey(dat.line.creation_date)

				if(!data[dataIndex]){
					data[dataIndex] = []
				}
				if(!data[dataIndex].find(element => String(element.xaxis) === 
						String(xaxis) ))
				{
					if(!labels.find(elem => String(elem) === String(xaxis))) labels.push(String(xaxis))
					data[dataIndex].push({xaxis: xaxis, yaxis: dat.line.base_price, 
						label: this.labelForChart(dat.line.base_price, dataIndex, ops)})
				}else{

					data[dataIndex].map(elem => {
						if(String(elem.xaxis) === xaxis){
							elem.yaxis+= dat.line.base_price
							elem.label = this.labelForChart(elem.yaxis, dataIndex, ops)
						}
						return elem
					})
				}
			}) 
			
			for(const attr in data){
				finalData.push(data[attr])
			}	
		}
		return {data: finalData, labels}
	}

	labelForChart(price, operationId, operations){
		return this.roundAndEuro(price)+' '+operations?.find(elem => String(elem._id) === String(operationId))?.name
	}

	roundAndEuro(price){
		return (Math.round(price * 100) / 100)+'€' 
	}

	parseResponse(response) {
		if (response.status === 'OK') {
			const statistics = {
				total_bills: response.statistics.total_bills,
				total_base_price: this.roundAndEuro(response.statistics.total_base_price),
				total_tax_price: this.roundAndEuro(response.statistics.total_tax_price),
				total_period_price: this.roundAndEuro(response.statistics.total_period_price)
			}

			this.setState(prevState => {
				return {
					...prevState,
					operations: response.operations,
					economicData: response.economicData,
					totalItems: response.totalItems, 
        			totalPages: response.totalPages, 
        			currentPage: response.currentPage,
					statistics: statistics,
					extra_data: response.extra_data?response.extra_data.map(ed => {
						ed.base_price = this.roundAndEuro(ed.base_price)
						ed.tax_price = this.roundAndEuro(ed.tax_price)
						ed.line_total_price = this.roundAndEuro(ed.line_total_price)
						return ed
					}):this.state.extra_data,
					selectedMonthsChartData: this.fillSelectedMonthsChartData(response),
					i18n: response.i18n
				}
			});
		} else if (response.auth === false) {
			this.navigateTo('/login');
		}
	}

	parseReportResponse(response){
		if (response.status === 'OK') {

			const extraData = response.extra_data?.map(ed => {
				ed.base_price = this.roundAndEuro(ed.base_price)
				ed.tax_price = this.roundAndEuro(ed.tax_price)
				ed.line_total_price = this.roundAndEuro(ed.line_total_price)
				return ed
			})

			const statistics = {
				total_bills: response.statistics.total_bills,
				total_base_price: this.roundAndEuro(response.statistics.total_base_price),
				total_tax_price: this.roundAndEuro(response.statistics.total_tax_price),
				total_period_price: this.roundAndEuro(response.statistics.total_period_price)
			}

			this.setState(prevState => {
				return {
					...prevState,
					totalItems: response.totalItems,
					totalPages: response.totalPages,
					currentPage: response.currentPage,
					economicData: response.economicData,
					extra_data: extraData,
					statistics: statistics,
					selectedMonthsChartData: this.fillSelectedMonthsChartData(response),
				}
			});

		} else if (this.state.download) {//Es download
			this.setState(prevState => {
				return {
					...prevState,
					download: 0
				}
			});

			const newBlob = new Blob([response], { type: 'application/octet-stream' });

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
			} else {
				// For other browsers: create a link pointing to the ObjectURL containing the blob.
				const objUrl = window.URL.createObjectURL(newBlob);

				let link = document.createElement('a');
				link.href = objUrl;
				link.download = "Informe.xlsx";
				link.click();

				// For Firefox it is necessary to delay revoking the ObjectURL.
				setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
			}
		} else if (response.auth === false) {
			this.navigateTo('/login');
		}
	}

	altTab(tabId){
		const tabs = ['data', 'charts', 'summary'];
	
		for (let tab in tabs){
			$('#'+tabs[tab]).css("display", "none");
			$('#'+tabs[tab]+"Tab").removeClass("active");
		}
	
		$('#'+tabId).css("display", "block");
		$('#'+tabId+"Tab").addClass("active");
		//aria-current="page"
	}

	showFilters() {
		
		let selectedFilters = {
			reports_date: { 
				start: this.props.selectedFilters.reports_date !== undefined?
					this.props.selectedFilters.reports_date.start: this.state.initialStartDate, 
				end: this.props.selectedFilters.reports_date !== undefined?
					this.props.selectedFilters.reports_date.end:this.state.initialEndDate,
				active: this.props.selectedFilters.reports_date!== undefined?
					this.props.selectedFilters.reports_date.active:this.state.initialActiveReportDate
			 },
			 operations: {
				collection: this.props.selectedFilters.operations !== undefined?
					this.props.selectedFilters.operations.collection: this.state.operations,
				active: this.props.selectedFilters.operations!== undefined?
					this.props.selectedFilters.operations.active:this.state.initialActiveOperations
			 },
			 billType: {
				collection: this.props.selectedFilters.billType !== undefined?
					this.props.selectedFilters.billType.collection: this.state.billType,
				active: this.props.selectedFilters.billType!== undefined?
					this.props.selectedFilters.billType.active:this.state.initialActiveBillType
			 }
		}
console.log("selectedFilters:::::::::::::::::::::::::::::::: ",selectedFilters, this.props.filtersContent, this.props.selectedFilters)

		this.props.setSelectedFilters(selectedFilters);

		
		this.props.setFiltersContent({
			title: 'Edite sus filtros',
			reports_date: { 
				start: this.props.selectedFilters.reports_date !== undefined?
					this.props.selectedFilters.reports_date.start: this.state.initialStartDate, 
				end: this.props.selectedFilters.reports_date !== undefined?
					this.props.selectedFilters.reports_date.end:this.state.initialEndDate,
				active: this.props.selectedFilters.reports_date!== undefined?
					this.props.selectedFilters.reports_date.active:this.state.initialActiveReportDate
			 },
			 operations: {
				collection: this.props.filtersContent?.operations !== undefined?
					this.props.filtersContent.operations.collection: this.state.operations,
				active: this.props.filtersContent?.operations!== undefined?
					this.props.filtersContent.operations.active:this.state.initialActiveOperations
			 },
			 billType: {
				collection: this.props.filtersContent?.billType !== undefined?
					this.props.filtersContent.billType.collection: this.state.billType,
				active: this.props.filtersContent?.billType!== undefined?
					this.props.filtersContent.billType.active:this.state.initialActiveBillType
			 },
			buttons: [
				{ shown: 'Aplicar', close: true, callback: this.filterResults, behaviour: 'main' },
				{ shown: 'Cerrar', close: true }
			]
		});

		$("#filters-component").modal('toggle');
	}

	filterResults() {
		let filters = [];

		let reportDateModified = false
		let operationsModified = false
		let billTypeModified = false

console.log("Todos los props selectedFilters:: ",this.props.selectedFilters)

		for (let prop in this.props.selectedFilters) {
			if (prop === 'reports_date') {
				if(this.props.selectedFilters[prop].active){
					reportDateModified = {
						start: this.parseDateToString(this.props.selectedFilters[prop].start),
						end: this.parseDateToString(this.props.selectedFilters[prop].end)
					}

					filters.push({ name: "reports_date_start", value: this.parseDateToString(this.props.selectedFilters[prop].start) });
					filters.push({ name: "reports_date_end", value: this.parseDateToString(this.props.selectedFilters[prop].end) });
				}
			}
			if (prop === 'operations') {
				if(this.props.selectedFilters[prop].active){
					operationsModified = this.props.selectedFilters[prop].collection
					filters.push({ name: "operation_in", value: operationsModified.map(op => op._id?op._id:op) });
				}
			}
			if (prop === 'billType') {
				if(this.props.selectedFilters[prop].active){
					billTypeModified = this.props.selectedFilters[prop].collection
					filters.push({ name: "type_in", value: billTypeModified.map(op => op._id?op._id:op) });
				}
			}
		}

//console.log("Filtros finales: ", filters)
		//TODO:: Hay que refactorizar todo esto porque depende soo de reportDate, pero habra muchos mas filtros
		if(reportDateModified){
			this.setState(prevState => {
				return {
					...prevState,
					page: 1,
					searchParams: filters,
					initialStartDate: reportDateModified.start,
					initialEndDate: reportDateModified.end,
				}
			}, this.reloadData);
		}else{
			this.setState(prevState => {
				return {
					...prevState,
					page: 1,
					searchParams: filters
				}
			}, this.reloadData);
		}
	}

	reloadData(){
		this.getInterface()
	}

	clickPaginationCallback(pageNumber) {
		this.setState(prevState => {
			return {
				...prevState,
				page: pageNumber
			}
		}, this.getInterface);
	}

	parseDateToString(date) {
		if(typeof date !== 'object') return date

		const hoursFromTimezoneOffset = (date.getTimezoneOffset() * -1) / 60;
		let dateToString = new Date(date.getTime());
		dateToString.setHours(date.getHours() + hoursFromTimezoneOffset);

		return dateToString.getUTCFullYear() + "-" +
			("0" + (dateToString.getUTCMonth() + 1)).slice(-2) + "-" +
			("0" + dateToString.getUTCDate()).slice(-2) + " " +
			("0" + dateToString.getUTCHours()).slice(-2) + ":" +
			("0" + dateToString.getUTCMinutes()).slice(-2) + ":" +
			("0" + dateToString.getUTCSeconds()).slice(-2);
	}

	parseToInterfaceDate(stringDate){
		try {
			var parts = stringDate.split(' ');
			parts = parts[0].split('-');
			return  parts[2]+'/'+parts[1]+'/'+parts[0]
		}catch(error){
			return stringDate
		}
	}

	render() {

		return (
			<div className="container">
				<Menu />
				<h3>{this.getTrad('Reports')}</h3>

				<div className="row mt-4" style={{ display: 'block' }}>
					<div className="col-12">
						<div className='row'>
							<div className="col-4 text-center">
								<button className="btn btn-secondary" onClick={this.showFilters}>Mostrar filtros</button>
							</div>
							<div className="col-4 text-right">
								<button className="btn btn-secondary" onClick={this.excelExport}>Exportar a excel</button>
							</div>
						</div>
						<div className='row mt-2'>
							<div className='col-12'>
								<ul className="nav nav-tabs">
								<li className="nav-item">
										<a id="summaryTab" to={''} className="nav-link active" href="dummie" 
											onClick={(e) => { e.preventDefault(); this.altTab('summary')}}>
											Resumen
										</a>
									</li>
									<li className="nav-item">
										<a id="dataTab" to={''} className="nav-link" aria-current="page" href="dummie" 
											onClick={(e) => { e.preventDefault(); this.altTab('data') }}>
											Informe
										</a>
									</li>
									<li className="nav-item">
										<a id="chartsTab" to={''} className="nav-link" href="dummie" 
											onClick={(e) => { e.preventDefault(); this.altTab('charts')}}>
											Gráficos
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className='row' id="data" style={{ display: 'none' }}>
							<div className="col-12">
								<Table
									config={{
										items: this.state.economicData?this.state.economicData:[],
										extra_data: this.state.extra_data?this.state.extra_data:[],
										i18n: this.state.i18n !== undefined ? this.state.i18n : [],
										mapping: [
											{
												original: 'code', shown: this.getTrad('Factura'), visible: true
											},
											{
												original: 'creation_date', shown: 'Fecha creación', visible: true, display: 'extra_data', 
												extra_data: {match: '_id', value: 'creation_date'}
											},
											{
												original: '_id', shown: 'Tipo de operación', visible: true, display: 'extra_data', 
												extra_data: {match: '_id', value: 'operation'}
											},
											{
												original: 'client', shown: 'Cliente', visible: true, display: 'extra_data', 
												extra_data: {match: '_id', value: 'client'}
											},
											{
												original: '_id', shown: this.getTrad('Delegación'), visible: true, display: 'extra_data', 
												extra_data: {match: '_id', value: 'location'}
											},
											{
												original: 'base_price', shown: 'Base imponible', visible: true, display: 'extra_data', textRight: 1, 
												extra_data: {match: '_id', value: 'base_price'}
											},
											{
												original: 'tax_price', shown: 'Impuestos', visible: true, display: 'extra_data', textRight: 1,
												extra_data: {match: '_id', value: 'tax_price'}
											},
											{
												original: 'line_total_price', shown: 'Total', visible: true, display: 'extra_data', textRight: 1,
												extra_data: {match: '_id', value: 'line_total_price'}
											},
											{ original: '_id', shown: '_id', visible: false }
											
										],
										pagination: {
											totalItems: this.state.totalItems ? this.state.totalItems : 0,
											totalPages: this.state.totalPages ? this.state.totalPages : 1,
											currentPage: this.state.currentPage ? this.state.currentPage : 1,
											callback: this.clickPaginationCallback
										}
									}}
								/>

							</div>
						</div>
					</div>
				</div>
				{/* Comienzo tab charts */}
				
				<div className="row" id="charts" style={{ display: 'none' }}>
					<div className="col-12">
						<h3 className="mt-2 ml-2">Ingresos por tipo de operación</h3>
						{this.state.selectedMonthsChartData && 
						<StackBarChart height={200} 
							data={this.state.selectedMonthsChartData?.data??[]} 
							labels={this.state.selectedMonthsChartData?.labels??[]} 
						/>}
							
						<h3 className="mt-2 ml-2">Evolución del período seleccionado</h3>
				

						<LinesChart height={200} 
							data={this.state.selectedMonthsChartData?.data??[]} 
							labels={this.state.selectedMonthsChartData?.labels??[]} 
						/>
						
					</div>
				</div>
				
				{/* Fin tab charts */}

				{/* Comienzo tab Resumen */}
				
				<div className="row" id="summary">
					<div className="col-12">

						<div className="row">
							<div className="col-6">
								<table className="table table-striped table-bordered table-hover">
									<thead>
										<tr>
											<th scope="col" >Concepto</th> 
											<th scope="col  text-right" >Valor</th> 
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="p-1">Fecha inicio</td>
											<td className="p-1 text-right">
												{this.parseToInterfaceDate(this.state.searchParams?.length>0?
													this.state.searchParams.find(param => param.name === 'reports_date_start').value
													:this.initialStartDate)}
											</td>
										</tr>
										<tr>
											<td className="p-1">Fecha fin</td>
											<td className="p-1 text-right">
											{this.parseToInterfaceDate(this.state.searchParams?.length>0?
													this.state.searchParams.find(param => param.name === 'reports_date_end').value
													:this.initialEndDate)}
											</td>
										</tr>
										<tr>
											<td className="p-1">Tipos de operación</td>
											<td className="p-1 text-right">
												{this.props.selectedFilters?.operations?.collection?
												this.props.selectedFilters.operations.collection.map(op => {
													const myOp = this.state.operations?.find(allOps => String(allOps._id) === String(op))
													if(!myOp) return ''
													return <p style={{marginBottom: '0px'}} key={"op_statistics_"+myOp._id}>{myOp.name}</p>
												}):''}
											</td>
										</tr>
										<tr>
											<td className="p-1">Tipos de factura</td>
											<td className="p-1 text-right">
												{this.props.selectedFilters?.billType?.collection?
												this.props.selectedFilters.billType.collection.map(type => {
													const myType = this.state.billType?.find(allTypes => String(allTypes._id) === String(type))
													if(!myType) return ''
													return <p style={{marginBottom: '0px'}} key={"op_statistics_"+myType._id}>{myType.name}</p>
												}):''}
											</td>
										</tr>
										<tr>
											<td className="p-1">Número de facturas</td>
											<td className="p-1 text-right">{this.state.statistics?.total_bills}</td>
										</tr>
										<tr>
											<td className="p-1">Total base imponible</td>
											<td className="p-1 text-right">{this.state.statistics?.total_base_price}</td>
										</tr>
										<tr>
											<td className="p-1">Total impuestos</td>
											<td className="p-1 text-right">{this.state.statistics?.total_tax_price}</td>
										</tr>
										<tr>
											<td className="p-1">Total del período</td>
											<td className="p-1 text-right">{this.state.statistics?.total_period_price}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				{/* Fin tab Resumen */}

				<Filters />
				<Modal />
			</div>
		);
	}
}

const mapStatToProps = state => {
	return {
		selectedFilters: state.selectedFilters,
		filtersContent: state.filtersContent
	};
}

const mapDispatchToProps = dispatch => {
	return {
		setModalContent(modalContent) {
			dispatch(setModalContent(modalContent));
		},
		setFiltersContent(filtersContent) {
			dispatch(setFiltersContent(filtersContent));
		},
		setSelectedFilters(selectedFilters) {
			dispatch(setSelectedFilters(selectedFilters));
		}
	}
}

export default connect(mapStatToProps, mapDispatchToProps)(Reports)
